import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLogin from "./AdminLogin/AdminLogin";
import InstallationDetails from "./AppInstallations/InstallationDetails";
import CollectionDetails from "./AppInstallations/CollectionDetails";
import PaidUsers from "./AppInstallations/PaidUsers";
import NewInstallation from "./Page/NewInstallation";
import CancelledUser from "./Page/CancelledUser"; // ✅ Correct path
import StatusPage from "./StatusPage";

// ✅ Protects routes that require authentication
const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  return isAuthenticated ? children : <Navigate to="/admin-login" />;
};

const App = () => {
  return (
    <Routes>
      <Route path="/status" element={<StatusPage />} />

      {/* Public Login Route */}
      <Route path="/admin-login" element={<AdminLogin />} />

      {/* ✅ Protected: New Installations (Main Page) */}
      <Route
        path="/installations"
        element={
          <PrivateRoute>
            <NewInstallation />
          </PrivateRoute>
        }
      />

      {/* Optional route for /installations/new */}
      <Route
        path="/installations/new"
        element={
          <PrivateRoute>
            <NewInstallation />
          </PrivateRoute>
        }
      />

      {/* ✅ Protected: Installation Details */}
      <Route
        path="/details/:id"
        element={
          <PrivateRoute>
            <InstallationDetails />
          </PrivateRoute>
        }
      />

      {/* ✅ Protected: Collection Details */}
      <Route
        path="/collections/:id/*"
        element={
          <PrivateRoute>
            <CollectionDetails />
          </PrivateRoute>
        }
      />

      {/* ✅ Protected: Paid Users */}
      <Route
        path="/paid-users"
        element={
          <PrivateRoute>
            <PaidUsers />
          </PrivateRoute>
        }
      />

      {/* ✅ Protected: Cancelled Users */}
      <Route
        path="/cancelled-users"
        element={
          <PrivateRoute>
            <CancelledUser />
          </PrivateRoute>
        }
      />

      {/* Default redirect to login */}
      <Route path="/" element={<Navigate to="/admin-login" />} />

      {/* Catch-all: Redirect unknown routes to login */}
      <Route path="*" element={<Navigate to="/admin-login" />} />
    </Routes>
  );
};

export default App;
